import React, { FC } from 'react';

import classnames from 'classnames';

import SubNavigationLayout from './SubNavigationLayout';

import './CartNavigation.scss';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

type Props = {
    readonly isSticky: boolean;
    readonly isCheckout?: boolean;
};

const CartNavigation: FC<Props> = ({ isSticky, isCheckout }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <SubNavigationLayout
            left={
                <ul className="cart-navigation">
                    {!isSticky && (
                        <li>
                            <a
                                className="back-button"
                                onClick={() => {
                                    navigate(-1);
                                }}
                            >
                                <i className="material-icons bigger" aria-label="Go back">
                                    arrow_back
                                </i>
                            </a>
                        </li>
                    )}
                    <li>
                        <i className="material-icons big" aria-hidden={true}>
                            shopping_cart
                        </i>
                        <span>{t('cart.cart')}</span>
                    </li>
                    <li>
                        <i className="material-icons big" aria-hidden={true}>
                            keyboard_arrow_right
                        </i>
                    </li>
                    <li>
                        <span className={classnames(!isCheckout && 'muted')}>{t('cart.placeOrder')}</span>
                    </li>
                </ul>
            }
            isSticky={isSticky}
            width="50"
        />
    );
};

export default CartNavigation;
